import './index.css';
import { useEffect, useState } from 'react';
import { useRouteLocation, useLink } from 'react-router-stack';
import { Header, ScreenBackground, View, Text, RouteWrapper } from '../../../component';
import { Dots } from 'react-activity';
import 'react-activity/dist/Dots.css';
import Iframe from 'react-iframe';

const CashfreePayment = () => {
  const location = useRouteLocation();
  const [cashfreeURL, setCashfreeURL] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useLink();

  useEffect(() => {
    if (location.state) {
      const { cashfree_url = '' } = location.state as any;
      setCashfreeURL(cashfree_url);
    } else {
      navigate.goFirst('/');
    }
  }, []);

  const onClickBack = () => {
    try {
      navigate.goBackView();
    } catch (err) {
      navigate.go(-1);
    }
  };

  const onLoad = () => {
    setLoading(true);
  };
  const dimension = loading ? '100%' : '0px';
  return (
    <RouteWrapper>
      <ScreenBackground>
        <Header title={'Cashfree Payment'} onClickBack={onClickBack} />
        <View className="cashfree-payment-container">
          {!loading && (
            <View className={'cashfree-payment-loader'}>
              <Dots size={25} />
              <Text className={'cashfree-payment-title'}>
                {'Please do not refresh this page...'}
              </Text>
            </View>
          )}
          <Iframe
            onLoad={onLoad}
            url={cashfreeURL}
            width={dimension}
            height={dimension}
            position="relative"
          />
        </View>
      </ScreenBackground>
    </RouteWrapper>
  );
};
export default CashfreePayment;
